<button
    (click)="disabled() ? null : click()"
    [attr.data-uiType]="'button'"
    [attr.data-styleTarget]="id() + '-button'"
    [attr.data-testid]="currentTestId()"
    [id]="id()"
    [attr.data-styleDisabled]="disabled()"
    class="cursor-pointer"
>
    <span
        [attr.data-styleTarget]="id() + '-label'"
        class="iq-md iq-md-icon-label"
        [datiqTemplateMd]="label()"
        [attr.data-uiType]="'button-label'"
    ></span>
</button>
